@if (versionCheck.updateAvailable()) {
  <div class="version-card" role="alert">
    <span class="version-icon">
      <i class="pi pi-sync" aria-hidden="true"></i>
    </span>
    <span class="version-text">A new version of Quotiss is available.</span>
    <button pButton size="small" type="button" (click)="versionCheck.reload()">
      Reload
    </button>
    <button
      (click)="versionCheck.dismiss()"
      type="button"
      class="version-close"
      aria-label="Close"
    >
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>
}
